module.exports = __webpack_public_path__ + "static/media/foto4.4398f6bc.png";